import React from 'react';

import { FormattedMessage } from 'translations';
import { FormattedMessage as MzFormattedMessage } from 'mz-intl';
import CheckboxField from 'mz-ui-kit/form/CheckboxField';
import mzMessages from '../Trip/messages.intl';

import { BlackLabel } from './elements';

const messages = {
  meetAndGreet: { id: 'SEARCH_RESULTS.AMENITIES.MEET_AND_GREET' },
  showOptions: { id: 'SEARCH_RESULTS.SHOW_ONLY_VEHICLE_CLASS' },
};

/**
 * Filter Meet and Greet, checkbox used to filter searches by meet & greet
 * @param {Function} onChange
 * @param {Boolean} value
 * @return React.Node
 */
export default function FilterMeetAndGreet ({ onChange, value, vehicleClass }) {
  if (!vehicleClass) return null
  const vehicleClassTooltipMessage = mzMessages[`VEHICLE_CLASS_${vehicleClass}`]

  return (
    <CheckboxField
      input={{
        onChange,
        value
      }}
      label={(
        <BlackLabel>
          <FormattedMessage
            {...messages.showOptions}
            values={{
              vehicleClass: <MzFormattedMessage tagName="b" message={vehicleClassTooltipMessage} />
            }}
          />
        </BlackLabel>
      )}
    />
  );
}
